export default __webpack_public_path__ + "static/media/WT Logo.235f8232.png";